// Trilingual field resolution: FR canonical + per-locale overrides.
// Mirrors the hub's resolver exactly.
export function pick(row, locale, field) {
  if (!row) return '';
  if (locale === 'fr') return row[field] || '';
  return (row.translations?.[locale]?.[field]) || row[field] || '';
}

export const LOCALES = ['fr', 'nl', 'en'];
export const DEFAULT_LOCALE = 'fr';

// Enums are language-agnostic codes — labels translated client-side.
const EMPLOYMENT_TYPE_LABELS = {
  fr: {
    flexi: 'Flexi-job', full_time: 'Temps plein', part_time: 'Temps partiel',
    student: 'Étudiant', internship: 'Stage', freelance: 'Indépendant',
    temporary: 'Intérim', other: 'Autre',
  },
  nl: {
    flexi: 'Flexi-job', full_time: 'Voltijds', part_time: 'Deeltijds',
    student: 'Student', internship: 'Stage', freelance: 'Freelance',
    temporary: 'Tijdelijk', other: 'Andere',
  },
  en: {
    flexi: 'Flexi-job', full_time: 'Full-time', part_time: 'Part-time',
    student: 'Student', internship: 'Internship', freelance: 'Freelance',
    temporary: 'Temporary', other: 'Other',
  },
};

const REMOTE_POLICY_LABELS = {
  fr: { on_site: 'Sur place', hybrid: 'Hybride', remote: 'Télétravail' },
  nl: { on_site: 'Op locatie', hybrid: 'Hybride', remote: 'Telewerk' },
  en: { on_site: 'On-site', hybrid: 'Hybrid', remote: 'Remote' },
};

export function employmentTypeLabel(code, locale) {
  if (!code) return '';
  return EMPLOYMENT_TYPE_LABELS[locale]?.[code] || EMPLOYMENT_TYPE_LABELS.fr[code] || code;
}

export function remotePolicyLabel(code, locale) {
  if (!code) return '';
  return REMOTE_POLICY_LABELS[locale]?.[code] || REMOTE_POLICY_LABELS.fr[code] || code;
}

// Default public-board ordering: sort_order ASC, is_featured DESC,
// published_at DESC, created_at DESC. The API already returns this order;
// we re-apply it defensively after grouping.
export function compareJobs(a, b) {
  const so = (a.sort_order ?? 0) - (b.sort_order ?? 0);
  if (so !== 0) return so;
  if (a.is_featured !== b.is_featured) return a.is_featured ? -1 : 1;
  const pub = String(b.published_at || '').localeCompare(String(a.published_at || ''));
  if (pub !== 0) return pub;
  return String(b.created_at || '').localeCompare(String(a.created_at || ''));
}
